<script setup lang="ts">
const route = useRoute();
import { storeToRefs } from "pinia";
import { useArticleStore } from "@/stores/article";

const articleStore = useArticleStore();
articleStore.fetchCategories();
articleStore.fetchAll({
  per_page: 6,
  category: route.query.category,
});
const { items, pagination, categories } = storeToRefs(articleStore);

definePageMeta({
  layout: "default",
});

const title = "DOGFUL(ドッグフル) | マガジンTOPページです。";
const description =
  "DOGFUL(ドッグフル)| マガジンではお出かけ・旅行、ペットグッズのレビューなどを発信しています";

useHead({
  title,
  meta: [
    { name: "description", content: description },
    { name: "og:title", content: title },
    { name: "og:description", content: description },
    { name: "twitter:title", content: title },
  ],
});

async function paginationUpdated(page) {
  const query = {
    per_page: 6,
    page,
    category: route.params.category,
  };
  articleStore.fetchAll(query);
  window.scrollTo(0, 0);
}
</script>

<template lang="pug">
section
  v-container
    v-row(align="center" justify="center")
      v-col(cols="12").text-center
        h2 MAGAZINE
        span.scroll-top
    v-row(no-gutters align="center" justify="center")
      v-col(cols="12").text-center
        h3 マガジン
    v-row(align="center" justify="center")
      v-col(cols="12").hashtags
        a(href="/articles") #全て
        a(:href="`/articles?category=${category.slug}`" v-for="category in categories") {{`#${category.name}`}}
    v-container(fluid mb-sm-12)
      v-row
        v-col(
          v-for="article in items"
          :key="article.id"
          cols="6"
          class="card-col"
        )
          v-card(
            outlined
            link
            :href="article.detailPath"
          )
            v-img(
                :src="article.top_image.thumb.url"
                itemprop="image"
                height="auto"
              )
            v-card-subtitle(class="pt-1")
              v-row(no-gutters align="center" class="ma-0")
                v-col
                  span(class="published-at") {{article.published_at}}
                v-col
                  v-chip(
                    class="ma-1"
                    size="x-small"
                  ) {{article.category.name}}
                v-spacer
            v-card-title(
              class="pa-1 ma-1"
            )
              h3 {{article.title }}
            v-card-subtitle(class="pt-1 pb-1")
              v-row()
                v-col
                  v-avatar(:image="article.author.image.icon.url" size="x-small")
                  span(class="author") {{article.author.name}}
      v-row(align="center" justify="center")
        v-col(
          class="col-12 col-sm-6 col-md-6"
        )
          v-pagination(
            v-model="pagination.current_page"
            class="my-4"
            :length="Math.round(pagination.total_count / pagination.per_page)"
            @update:model-value="paginationUpdated"
            :total-visible="3"
          )





</template>

<style lang="scss" scoped>
.v-card-title {
  font-size: 16px;
  letter-spacing: -0.56px;
  line-height: 21px;
  margin: 15px 0;
  text-align: left;
  color: #2a2929;
  white-space: inherit;
}

.hashtags {
  text-align: center;
  height: auto;
  list-style: none;
  text-align: center;
  line-height: 30px;

  a {
    padding: 15px;
    text-decoration: none !important;
    color: #707070 !important;
  }
}
@media (max-width: 576px) {
  .v-container {
    padding: 10px;
    .v-card-title {
      font-size: 12px;
      line-height: 18px;
    }
    .v-card-subtitle {
      font-size: 0.7rem;
    }
    .card-col {
      padding: 3px;
    }
  }
}
</style>
